import type { CartType, ProductType } from '@/types/domains/index';

export class ProductPresenter {
  async getProduct(code: string): Promise<ProductType.Product> {
    return useProduct().getProduct(code);
  }

  async postCart(params: CartType.PostCartParams): Promise<CartType.CartResponse | null> {
    return useCart().postCart(params);
  }
}
